import { supabase } from '@/lib/supabase';

/** Inscription d'un visiteur à un événement du marchand. */
export interface EventRegistrationInput {
  eventId: number;
  merchantId: string | number | null;
  fullname: string;
  email?: string;
  phone?: string;
  seats?: number;
  note?: string;
}

export interface EventRegistration {
  id: number;
  event_id: number;
  merchant_id: string | null;
  fullname: string;
  email: string | null;
  phone: string | null;
  seats: number | null;
  note: string | null;
  status: string | null;
  created_at: string | null;
}

/** Enregistre une inscription à un événement (données réelles, aucune simulation). */
export async function registerToEvent(input: EventRegistrationInput): Promise<EventRegistration> {
  const payload = {
    event_id: input.eventId,
    merchant_id: input.merchantId != null ? String(input.merchantId) : null,
    fullname: input.fullname.trim(),
    email: input.email?.trim() || null,
    phone: input.phone?.trim() || null,
    seats: Math.max(1, Number(input.seats) || 1),
    note: input.note?.trim() || null,
    status: 'confirmed',
  };
  const { data, error } = await supabase
    .from('event_registrations')
    .insert(payload)
    .select('*')
    .single();
  if (error) throw error;
  return data as EventRegistration;
}

/** Nombre de places déjà réservées pour un événement. */
export async function countEventRegistrations(eventId: number): Promise<number> {
  const { data, error } = await supabase
    .from('event_registrations')
    .select('seats')
    .eq('event_id', eventId);
  if (error) return 0;
  return ((data || []) as { seats: number | null }[]).reduce((sum, row) => sum + (Number(row.seats) || 0), 0);
}

/** Liste des inscriptions d'un événement (espace marchand). */
export async function fetchEventRegistrations(eventId: number): Promise<EventRegistration[]> {
  const { data, error } = await supabase
    .from('event_registrations')
    .select('*')
    .eq('event_id', eventId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data || []) as EventRegistration[];
}